import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import { SUP_EMPLOYEE_LIST, SUP_EMPLOYEE_ADD, SUP_EMPLOYEE_DETAIL, SUP_EMPLOYEE_UPDATE, SUP_EMPLOYEE_FILTER_SUPPLIERS } from '../../actions';
import {
  SupplierEmployeeListSuccess, SupplierEmployeeListError,
  SupplierEmployeeAddSuccess, SupplierEmployeeAddError,
  SupplierEmployeeDetailSuccess, SupplierEmployeeDetailError,
  SupplierEmployeeUpdateSuccess, SupplierEmployeeUpdateError,
  SupplierEmployeeFilterSuppliersSuccess
} from '../../actions';

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => { unsubscribe(); resolve(token); });
    }, reject);
  });
}

const onListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'supplier/employee/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'supplier/employee/add', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data.payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { message: true, data: response };
};

const onDetailAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'supplier/employee/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'supplier/employee/update', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data)
  }).then(r => r.json()).catch(err => console.log(err));
  return { message: true, data: response };
};

const onFilterSuppliersAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/delivery_plan/suppliers', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify({})
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

function* onList(data) {
  try { const response = yield call(onListAsync, data.payload); yield put(SupplierEmployeeListSuccess(response.data)); }
  catch (error) { yield put(SupplierEmployeeListError(error)); }
}

function* onAdd(data) {
  try {
    const response = yield call(onAddAsync, data);
    if (response.data.status === true) NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    else if (response.data.status === 'error') NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    yield put(SupplierEmployeeAddSuccess(response.data));
  } catch (error) { yield put(SupplierEmployeeAddError(error)); }
}

function* onDetail(data) {
  try { const response = yield call(onDetailAsync, data.payload); yield put(SupplierEmployeeDetailSuccess(response.data.data)); }
  catch (error) { yield put(SupplierEmployeeDetailError(error)); }
}

function* onUpdate(data) {
  try {
    const response = yield call(onUpdateAsync, data.payload);
    if (response.data.status === true) NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    else if (response.data.status === 'error') NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    yield put(SupplierEmployeeUpdateSuccess(response.data));
  } catch (error) { yield put(SupplierEmployeeUpdateError(error)); }
}

function* onFilterSuppliers() {
  try { const response = yield call(onFilterSuppliersAsync); yield put(SupplierEmployeeFilterSuppliersSuccess(response.data.data || [])); }
  catch (error) { console.error(error); }
}

export function* watchList() { yield takeEvery(SUP_EMPLOYEE_LIST, onList); }
export function* watchAdd() { yield takeEvery(SUP_EMPLOYEE_ADD, onAdd); }
export function* watchDetail() { yield takeEvery(SUP_EMPLOYEE_DETAIL, onDetail); }
export function* watchUpdate() { yield takeEvery(SUP_EMPLOYEE_UPDATE, onUpdate); }
export function* watchFilterSuppliers() { yield takeEvery(SUP_EMPLOYEE_FILTER_SUPPLIERS, onFilterSuppliers); }

export default function* rootSaga() {
  yield all([fork(watchList), fork(watchAdd), fork(watchDetail), fork(watchUpdate), fork(watchFilterSuppliers)]);
}
